import Vue from 'vue';
import Router from 'vue-router';
import helpCenter from './help-center';
import store from '../store/index';
import cookie from '../cookie/cookie';
import orangeLoan from './console/orange-loan';
import contract from './console/contract';
import repayment from './console/repayment';
import insurance from './console/insurance';
import insManage from './console/ins-manage';
import insClaim from './console/ins-claim';
import balance from './console/balance';
import userInfo from './console/user-info';
import userManage from './console/user-manage';
import noticeRouter from './console/notice-manage';
import vehicleManage from './console/vehicle-manage';
import driverManage from './console/driver-manage';
import driverRewardModel from './console/driver-reward';
import violationManage from './console/violation-manage';
import consoleHome from './console/console-home';
import fundLoanManage from './console-fund/loan-manage';
import fundBalanceManage from './console-fund/balance';
import loanManage from './console/loan-manage';
import fundDataCenter from './console-fund/data-center';
Vue.use(Router);
var router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: function () { return import('../views/home.vue'); },
        },
        {
            path: '/loan-introduce',
            component: function () { return import('../views/loan-introduce.vue'); },
        },
        {
            name: 'aboutus',
            path: '/aboutus',
            component: function () { return import('../views/about-us.vue'); },
        },
        {
            name: 'contractAgreement',
            path: '/agreement',
            component: function () { return import('../views/contract/contract-agreement.vue'); },
        },
        {
            name: 'loanAgreement',
            path: '/loan-agreement',
            component: function () { return import('../views/insurance/loan-agreement.vue'); },
        },
        {
            name: 'repaymentAgreement',
            path: '/repayment-agreement',
            component: function () { return import('../views/insurance/repayment-agreement.vue'); },
        }
    ].concat(helpCenter, [
        {
            path: '/console',
            component: function () { return import('../components/m-layout.vue'); },
            children: [
                {
                    name: 'board',
                    path: 'board',
                    component: function () { return import('../components/console-common/board.vue'); },
                },
                {
                    name: 'consoleHome',
                    path: 'overview',
                    component: function () { return import('../views/home/console-router.vue'); },
                    children: consoleHome,
                },
                {
                    name: 'contractHome',
                    path: 'contract',
                    component: function () { return import('../views/contract/contract-home.vue'); },
                    children: contract,
                },
                {
                    name: 'repayment',
                    path: 'repayment-plan',
                    component: function () { return import('../views/repayment/repayment-home.vue'); },
                    children: repayment,
                },
                {
                    name: 'insuranceHome',
                    path: 'insurance',
                    component: function () { return import('../views/insurance/insurance-home.vue'); },
                    children: insurance,
                },
                {
                    name: 'insManageHome',
                    path: 'ins-management',
                    component: function () { return import('../views/ins-manage/ins-manage-home.vue'); },
                    children: insManage,
                },
                {
                    name: 'insClainHome',
                    path: 'ins-claim',
                    component: function () { return import('../views/ins-claim/ins-claim-home.vue'); },
                    children: insClaim,
                },
                {
                    name: 'balanceHome',
                    path: 'balance-msg',
                    component: function () { return import('../views/balance-msg/balance-home.vue'); },
                    children: balance,
                },
                {
                    name: 'orangeLoan',
                    path: 'orange-loan',
                    component: function () { return import('../views/orange-loan/loan-home-enter.vue'); },
                    children: orangeLoan,
                },
                {
                    name: 'userInfoHome',
                    path: 'user-info',
                    component: function () { return import('../views/user-info/user-info-home.vue'); },
                    children: userInfo,
                },
                {
                    name: 'userManageHome',
                    path: 'user-manage',
                    component: function () { return import('../views/user-manage/user-manage-home.vue'); },
                    children: userManage,
                },
                {
                    name: 'noticeHome',
                    path: 'notice',
                    component: function () { return import('../views/notice-model/notice-home.vue'); },
                    children: noticeRouter,
                },
                {
                    name: 'vehicleManageHome',
                    path: 'vehicle',
                    component: function () { return import('../views/vehicle-manage/vehicle-manage-home.vue'); },
                    children: vehicleManage,
                },
                {
                    name: 'driverManageHome',
                    path: 'driver',
                    component: function () { return import('../views/driver-manage/driver-manage-home.vue'); },
                    children: driverManage,
                },
                {
                    name: 'driverRewardHome',
                    path: 'driver',
                    component: function () { return import('../views/driver-reward/driver-reward-home.vue'); },
                    children: driverRewardModel,
                },
                {
                    name: 'violationManageHome',
                    path: 'violation',
                    component: function () { return import('../views/violation-manage/violation-manage-home.vue'); },
                    children: violationManage,
                },
                {
                    name: 'fundLoanManageHome',
                    path: 'fund-loan-manage',
                    component: function () { return import('../views/fund/loan-manage/loan-manage-home.vue'); },
                    children: fundLoanManage,
                },
                {
                    name: 'fundBalanceManage',
                    path: 'fund-balance-manage',
                    component: function () { return import('../views/fund/balance/fund-balance-home.vue'); },
                    children: fundBalanceManage,
                },
                {
                    name: 'fundDataCenter',
                    path: 'fund-data-center',
                    component: function () { return import('../views/fund/data-center/data-center-home.vue'); },
                    children: fundDataCenter,
                },
                {
                    name: 'loanManageHome',
                    path: 'loan-manage',
                    component: function () { return import('../views/loan-manage/loan-manage-home.vue'); },
                    children: loanManage,
                },
            ],
        },
        {
            name: 'login',
            path: '/sso/login',
            component: function () { return import('../views/login.vue'); },
        },
        // 活动扫码btob
        {
            name: 'activity-btob',
            path: '/activity-btob',
            component: function () { return import('../views/activity-btob.vue'); },
        },
        {
            path: '/*',
            component: function () { return import('../views/home.vue'); },
        },
    ]),
});
router.beforeEach(function (to, from, next) {
    var usernameZh = cookie.getCookie('usernameZh');
    var merchant_status = cookie.getCookie('merchant_status');
    var reg = /^\/[^\/]+$/;
    if (!reg.test(to.path) && to.path.search('console') !== -1 && (!usernameZh || merchant_status !== '3')) {
        next('/');
    }
    else {
        var activeMenu = '';
        var openMenu = '';
        var featureList = store.state.user.featureList;
        var feature_1 = featureList.find(function (f) {
            return f.url === to.path;
        });
        if (!featureList) {
            next('/');
        }
        if (feature_1) {
            activeMenu = feature_1.resourceCode;
            var fea = featureList.find(function (f) { return f.resourceCode === feature_1.resourceCode; });
            if (fea) {
                openMenu = fea.parentCode;
            }
            store.commit('user/update', {
                activeMenu: activeMenu,
                openMenu: openMenu,
            });
            store.commit('common/update', {
                commonBread: Object.assign({}, {
                    prewRouterName: '',
                    prewName: '',
                    currentName: '',
                }),
            });
            next();
        }
        else {
            next();
            // if (to.path.indexOf('/console') !== -1) {
            //   next('/')
            // } else {
            //   next()
            // }
        }
    }
});
export default router;
